import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/vuex'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function(location) {
  return routerPush.call(this, location).catch(error => error)
}

import Login from '../views/login/login.vue' //登录页面
import Home from '../views/Home/Home.vue' //主页面

//系统设置
const SystemModule = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemModule.vue') //模块设置
const SystemRole = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemRole.vue') //角色管理
const SystemUser = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemUser.vue') //用户管理
const SystemCode = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemCode.vue') //系统代码
const SystemGlobal = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemGlobal.vue') //全局参数
const SystemCorporateAccount = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemCorporateAccount.vue') //企业账户
const SystemEnterpriseInformation = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemEnterpriseInformation.vue') //企业信息
const systemTransPriceRecordformation = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemTransPriceRecordformation.vue') //调价记录
const systemAbnormalOrder = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemAbnormalOrder.vue') //异常订单
const systemReportStatistics = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemReportStatistics.vue') //报表统计
const systemwlAdmin = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemwlAdmin.vue') //物料管理

const systemFeezeThawingRecord = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemFeezeThawingRecord.vue') //调价记录

//销售
const SalesCustomer = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesCustomer.vue') //客户管理
// const SalesBigCustomers = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesBigCustomers.vue') //客户管理
const SalesCarManagement = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesCarManagement.vue') //车辆管理
const SalesDeliveryPlace = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesDeliveryPlace.vue') //配送地
const SalesBigDeliveryPlace = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesBigDeliveryPlace.vue') //配送地--一级
const SalesMaterialPrice = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesMaterialPrice.vue') //物料价格管理
const SalesPreferential = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesPreferential.vue') //优惠管理
const SalesBillDetails = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesBillDetails.vue') //账单明细表
const SalesFreightBillDetails = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesFreightBillDetails.vue') //运费账单明细
const SalesDispatchManagement = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesDispatchManagement.vue') //派单记录
const salesPrintVote = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesPrintVote.vue') //流水记录
const SalesEntryOrder = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesEntryOrder.vue') //派单记录
const SalesFinancialAudit = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesFinancialAudit.vue') //财务审核
const PerformanceRecords = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/performanceRecords.vue') //提现记录
const SalesDataAnalysis = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesDataAnalysis.vue') //数据分析
const SalesCoupon = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesCoupon.vue') //优惠券管理
const SalesOwnerExamine = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/SalesOwnerExamine.vue') //车主审核
const SalesFreightOrder = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/SalesFreightOrder.vue') //运费订单
const SalesFreightInformation = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/SalesFreightInformation.vue') //运费信息
const salesslMaseg = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesslMaseg.vue') //收料信息
const salesLssueOrder = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesLssueOrder.vue') //一键发单
const salesPriceList = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesPriceList.vue') //价格表
const salesBill = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesBill.vue') //客户发票管理
const salesRecordExamine = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesRecordExamine.vue') //客户发票审核
const salesCouponRecord = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesCouponRecord.vue') //优惠券记录
const salesInvoice = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesInvoice.vue') //厂家发票设置
const saleCustomerInvoice = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/saleCustomerInvoice.vue') //客户发票管理
const saleInvoiceApproval = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/saleInvoiceApproval.vue') //开票审核
const salesWaybillExamine = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/salesWaybillExamine.vue') //财务审核
const billImportacion = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/billImportacion.vue') //账单导入
const SaleQueryOfVehicleTrajectory = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/saleQueryOfVehicleTrajectory.vue')
const freightAccount = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/freightAccount.vue') // 运费收支明细
const waybillTrajectory = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/waybillTrajectory.vue') // 运单轨迹
const rebateSetting = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/rebateSetting.vue') // 返点设置
const receiptShippingOrder = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/receiptShippingOrder.vue') //收料运费订单
const energyGoldDetail = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/energyGoldDetail.vue') //能源金明细
//油站系统
const oilCardBill = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/oilCardBill.vue') //油卡
const oilCzInfo = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/oilCzInfo.vue') //油站充值记录
const oilStation = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/oilStation.vue') //油站
const stationStaff = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/stationStaff.vue') //油站员工管理
const SaleRate = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/saleRate/index.vue') //费率列表
const SaleRateDetail = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/saleRate/detail.vue') //费率详情

const bridge = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/bridge.vue') //电桩管理
const bridgeDetails = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/bridgeDetails.vue') //电桩详情
const chargingOrder = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/chargingOrder.vue') //充电订单
const chargingOrderDetails = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/chargingOrderDetails') //订单详情
const pileEquipment = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/pileEquipment.vue') //枪桩设备
const alarmInformation = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/alarmInformation.vue') //告警信息
const vehicleManagement = () => import(/* webpackChunkName: "route-station" */ '../components/serviceStation/vehicleManagement.vue') //充电车辆管理
// 商砼站系统
const systemCommercialConcreteStand = () => import(/* webpackChunkName: "route-system" */ '../components/systemSettings/systemCommercialConcreteStand.vue') //调价记录

//营销系统
const marKetingSet = () => import(/* webpackChunkName: "route-marketing" */ '../components/marKeting/marKetingSet.vue') //营销系统-拉新记录
const marKetingLotteryRecord = () => import(/* webpackChunkName: "route-marketing" */ '../components/marKeting/marKetingLotteryRecord.vue') //营销系统-拉新记录
const marKetingCoupon = () => import(/* webpackChunkName: "route-marketing" */ '../components/marKeting/marKetingCoupon.vue') //营销系统-优惠券记录
const marKetingPointMsg = () => import(/* webpackChunkName: "route-marketing" */ '../components/marKeting/marKetingPointMsg.vue') //营销系统-返点信息
const marketingFreightSubsidyRecords = () => import(/* webpackChunkName: "route-marketing" */ '../components/marKeting/marketingFreightSubsidyRecords.vue')

//CRM系统
const CRMCustomer = () => import(/* webpackChunkName: "route-crm" */ '../components/CRM/CRMCustomer.vue') //客户管理
const CRMBillDetails = () => import(/* webpackChunkName: "route-crm" */ '../components/CRM/CRMBillDetails.vue') //账单明细表
const CRMPreferential = () => import(/* webpackChunkName: "route-crm" */ '../components/CRM/CRMPreferential.vue') //优惠管理
const oilCardExamine = () => import(/* webpackChunkName: "route-crm" */ '../components/CRM/oilCardExamine.vue') //油卡审核
const oilCardDivJoin = () => import(/* webpackChunkName: "route-crm" */ '../components/CRM/oilCardDivJoin.vue') //油卡预分配
const oilCardTrajectory = () => import(/* webpackChunkName: "route-crm" */ '../components/CRM/oilCardTrajectory.vue') //车辆轨迹
const CRMCarAdmin = () => import(/* webpackChunkName: "route-crm" */ '../components/CRM/CRMCarAdmin.vue') //车辆管理

//设备信息管理
const mortarTank = () => import(/* webpackChunkName: "route-device" */ '../components/mortarTank/mortarTank.vue') //砂浆罐管理
// 数据看板
const mapBoard = () => import(/* webpackChunkName: "route-board" */ '../components/dataBoard/mapBoard.vue') //地图可视化看板
const riskPerception = () => import(/* webpackChunkName: "route-board" */ '../components/dataBoard/riskPerception.vue') //风险感知数据看板
const userStatistics = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/userStatistics.vue')//用户统计

// 财务对账
const reconciliation = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/reconciliation.vue') //财务对账
const phase = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/phase.vue') //盈亏
const basePrice = () => import(/* webpackChunkName: "route-sales" */ '../components/sales/basePrice.vue')//厂家底价

// 财务系统/审核对公转账
const rechargeReconciliation = () => import(/* webpackChunkName: "route-finance" */ '../components/finance/rechargeReconciliation.vue') //充值对账管理
Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/Login', //重定向
      component: Login,
    },
    {
      path: '/Login', //登录页面
      name: 'Login',
      component: Login,
    },
    {
      path: '/Home', //主页面
      name: 'Home',
      component: Home,
      children: [
        //子路由
        {
          path: 'SystemModule', //模块设置
          name: 'SystemModule',
          component: SystemModule,
        },
        {
          path: 'SystemRole', //角色管理
          name: 'SystemRole',
          component: SystemRole,
        },
        {
          path: 'SystemUser', //用户管理
          name: 'SystemUser',
          component: SystemUser,
        },
        {
          path: 'SystemCode', //系统代码
          name: 'SystemCode',
          component: SystemCode,
        },
        {
          path: 'SystemGlobal', //全局参数
          name: 'SystemGlobal',
          component: SystemGlobal,
        },
        {
          path: 'SystemCorporateAccount', //企业账户
          name: 'SystemCorporateAccount',
          component: SystemCorporateAccount,
        },

        {
          path: 'SystemEnterpriseInformation', //企业信息
          name: 'SystemEnterpriseInformation',
          component: SystemEnterpriseInformation,
        },
        {
          path: 'systemTransPriceRecordformation', //企业信息
          name: 'systemTransPriceRecordformation',
          component: systemTransPriceRecordformation,
        },
        {
          path: 'systemFeezeThawingRecord', //企业信息
          name: 'systemFeezeThawingRecord',
          component: systemFeezeThawingRecord,
        },
        {
          path: 'systemwlAdmin', //物料管理
          name: 'systemwlAdmin',
          component: systemwlAdmin,
        },

        {
          path: 'systemCommercialConcreteStand', //商砼站信息
          name: 'systemCommercialConcreteStand',
          component: systemCommercialConcreteStand,
        },

        {
          path: 'systemAbnormalOrder', //企业信息
          name: 'systemAbnormalOrder',
          component: systemAbnormalOrder,
        },
        {
          path: 'systemReportStatistics', //企业信息
          name: 'systemReportStatistics',
          component: systemReportStatistics,
        },

        {
          path: 'SalesCustomer', //大客户管理
          name: 'SalesCustomer',
          component: SalesCustomer,
        },
        // {
        //   path: 'SalesBigCustomers', //大客户管理
        //   name: 'SalesBigCustomers',
        //   component: SalesBigCustomers,
        // },
        {
          path: 'SalesCarManagement', //车辆管理
          name: 'SalesCarManagement',
          component: SalesCarManagement,
        },
        {
          path: 'SaleQueryOfVehicleTrajectory', //车辆轨迹查询
          name: 'SaleQueryOfVehicleTrajectory',
          component: SaleQueryOfVehicleTrajectory,
        },
        {
          path: 'SalesDeliveryPlace', //配送地
          name: 'SalesDeliveryPlace',
          component: SalesDeliveryPlace,
        },
        {
          path: 'SalesBigDeliveryPlace', //配送地--一级
          name: 'SalesBigDeliveryPlace',
          component: SalesBigDeliveryPlace,
        },
        {
          path: 'SalesMaterialPrice', //物料价格管理
          name: 'SalesMaterialPrice',
          component: SalesMaterialPrice,
        },
        {
          path: 'SalesPreferential', //优惠管理
          name: 'SalesPreferential',
          component: SalesPreferential,
        },
        {
          path: 'SalesBillDetails', //账单明细表
          name: 'SalesBillDetails',
          component: SalesBillDetails,
        },
        {
          path: 'SalesFreightBillDetails', //运费账单明细
          name: 'SalesFreightBillDetails',
          component: SalesFreightBillDetails,
        },
        {
          path: 'SalesDispatchManagement', //派单记录
          name: 'SalesDispatchManagement',
          component: SalesDispatchManagement,
        },
        {
          path: 'salesPrintVote', //流水记录
          name: 'salesPrintVote',
          component: salesPrintVote,
        },

        {
          path: 'SalesEntryOrder', //录入
          name: 'SalesEntryOrder',
          component: SalesEntryOrder,
        },
        {
          path: 'SalesFinancialAudit', //财务审核
          name: 'SalesFinancialAudit',
          component: SalesFinancialAudit,
        },
        {
          path: 'PerformanceRecords', //提现记录
          name: 'PerformanceRecords',
          component: PerformanceRecords,
        },
        {
          path: 'SalesDataAnalysis', //数据分析
          name: 'SalesDataAnalysis',
          component: SalesDataAnalysis,
        },
        {
          path: 'SalesCoupon', //优惠券管理
          name: 'SalesCoupon',
          component: SalesCoupon,
        },
        {
          path: 'SalesOwnerExamine', //车主审核
          name: 'SalesOwnerExamine',
          component: SalesOwnerExamine,
        },
        {
          path: 'SalesFreightInformation', //运费信息
          name: 'SalesFreightInformation',
          component: SalesFreightInformation,
        },
        {
          path: 'salesslMaseg', //收料信息
          name: 'salesslMaseg',
          component: salesslMaseg,
        },

        {
          path: 'salesWaybillExamine', //运单审核
          name: 'salesWaybillExamine',
          component: salesWaybillExamine,
        },
        {
          path: 'billImportacion', //账单导入
          name: 'billImportacion',
          component: billImportacion,
        },

        {
          path: 'SalesFreightOrder', //运费订单
          name: 'SalesFreightOrder',
          component: SalesFreightOrder,
        },
        {
          path: 'salesLssueOrder', //一键发单
          name: 'salesLssueOrder',
          component: salesLssueOrder,
        },
        {
          path: 'salesPriceList', //价格表
          name: 'salesPriceList',
          component: salesPriceList,
        },
        {
          path: 'salesBill', //发票管理
          name: 'salesBill',
          component: salesBill,
        },
        {
          path: 'salesRecordExamine', //发票审核
          name: 'salesRecordExamine',
          component: salesRecordExamine,
        },

        {
          path: 'salesCouponRecord', //优惠券记录
          name: 'salesCouponRecord',
          component: salesCouponRecord,
        },
        {
          path: 'salesInvoice', //厂家发票设置
          name: 'salesInvoice',
          component: salesInvoice,
        },
        {
          path: 'oilCardBill', //油卡账单
          name: 'oilCardBill',
          component: oilCardBill,
        },
        {
          path: 'oilCzInfo', //油卡账单
          name: 'oilCzInfo',
          component: oilCzInfo,
        },
        {
          path: 'oilStation', //油卡账单
          name: 'oilStation',
          component: oilStation,
        },
        {
          path: 'stationStaff', //油站员工管理
          name: 'stationStaff',
          component: stationStaff,
        },
        {
          path: 'bridge', //电桩管理
          name: 'bridge',
          component: bridge,
          // children: [
          //   {
          //     path: "details", //电桩详情
          //     name: "bridgeDetails",
          //     component: bridgeDetails,
          //   },
          // ],
        },
        {
          path: 'bridgeDetails', //电桩详情
          name: 'bridgeDetails',
          component: bridgeDetails,
        },
        {
          path: 'saleCustomerInvoice', //客户发票管理
          name: 'saleCustomerInvoice',
          component: saleCustomerInvoice,
        },
        {
          path: 'saleInvoiceApproval', //开票审核
          name: 'saleInvoiceApproval',
          component: saleInvoiceApproval,
        },
        {
          path: 'marKetingSet', //营销系统-拉新记录
          name: 'marKetingSet',
          component: marKetingSet,
        },
        {
          path: 'marKetingLotteryRecord', //营销系统-抽奖记录
          name: 'marKetingLotteryRecord',
          component: marKetingLotteryRecord,
        },
        {
          path: 'marKetingCoupon', //营销系统-优惠券记录
          name: 'marKetingCoupon',
          component: marKetingCoupon,
        },
        {
          path: 'marketingFreightSubsidyRecords', //营销系统-优惠券记录
          name: 'marketingFreightSubsidyRecords',
          component: marketingFreightSubsidyRecords,
        },
        {
          path: 'marKetingPointMsg', //营销系统-优惠券记录
          name: 'marKetingPointMsg',
          component: marKetingPointMsg,
        },
        {
          path: 'CRMCustomer', //CRM-客户管理
          name: 'CRMCustomer',
          component: CRMCustomer,
        },
        {
          path: 'CRMBillDetails', //CRM-账单明细
          name: 'CRMBillDetails',
          component: CRMBillDetails,
        },
        {
          path: 'CRMPreferential', //CRM-优惠管理
          name: 'CRMPreferential',
          component: CRMPreferential,
        },
        {
          path: 'oilCardExamine', //CRM-油卡审核
          name: 'oilCardExamine',
          component: oilCardExamine,
        },
        {
          path: 'oilCardDivJoin', //CRM-油卡预分配
          name: 'oilCardDivJoin',
          component: oilCardDivJoin,
        },
        {
          path: 'oilCardTrajectory', //CRM-车辆轨迹
          name: 'oilCardTrajectory',
          component: oilCardTrajectory,
        },
        {
          path: 'CRMCarAdmin', //CRM-车辆管理
          name: 'CRMCarAdmin',
          component: CRMCarAdmin,
        },
        {
          path: 'mortarTank', //设备信息-砂浆罐管理
          name: 'mortarTank',
          component: mortarTank,
        },
        {
          path: 'SaleRate', //加油充电-费率列表
          name: 'SaleRate',
          component: SaleRate,
        },
        {
          path: 'SaleRateDetail', //加油充电-费率详情
          name: 'SaleRateDetail',
          component: SaleRateDetail,
        },
        {
          path: 'chargingOrder', //充电订单
          name: 'chargingOrder',
          component: chargingOrder,
        },
        {
          path: 'chargingOrderDetails', //订单详情
          name: 'chargingOrderDetails',
          component: chargingOrderDetails,
        },
        {
          path: 'pileEquipment', //枪桩设备
          name: 'pileEquipment',
          component: pileEquipment,
        },
        {
          path: 'alarmInformation', //告警信息
          name: 'alarmInformation',
          component: alarmInformation,
        },
        {
          path: 'freightAccount', //运费收支明细
          name: 'freightAccount',
          component: freightAccount,
        },
        {
          path: 'waybillTrajectory', //运单轨迹
          name: 'waybillTrajectory',
          component: waybillTrajectory,
        },
        {
          path: 'vehicleManagement', //充电车辆管理receiptShippingOrder
          name: 'vehicleManagement',
          component: vehicleManagement,
        },
        {
          path: 'rebateSetting', //返点设置
          name: 'rebateSetting',
          component: rebateSetting,
        },
        {
          path: 'receiptShippingOrder',
          name: 'receiptShippingOrder',
          component: receiptShippingOrder,
        },
        {
          path: 'energyGoldDetail',//能源金收支明细
          name: 'energyGoldDetail',
          component: energyGoldDetail,
        },
        {
          path:'mapBoard',//地图可视化看板
          name:'mapBoard',
          component:mapBoard
        },
        {
          path:'riskPerception',//风险感知数据看板
          name:'riskPerception',
          component:riskPerception
        },
        {
          path:'reconciliation',//财务对账
          name:'reconciliation',
          component:reconciliation
        },
        {
          path:'phase',//盈亏
          name:'phase',
          component:phase
        },
        {
          path:'basePrice',//厂家底价
          name:'basePrice',
          component:basePrice
        },
        {
          path:'userStatistics',//用户统计
          name:'userStatistics',
          component:userStatistics
        },
        {
          path: 'rechargeReconciliation', //银企充值对账管理
          name: 'rechargeReconciliation',
          component: rechargeReconciliation,
        },
      ],
    },
  ],
})
router.beforeEach((to, from, next) => {
  if (to.path === '/Login') {
    return next()
  } else {
    var uobj = sessionStorage.getItem('token')
    if (!uobj) {
      next('/Login')
    } else {
      next()
    }
  }
})
export default router
